/**
 * Generated runtime TestId mirror for frontend/src/pages/FunctionGroupRequestDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FunctionGroupRequestDetailTestIds = {
  btnCancelRequest: "btn-cancel-request",
  cardTitleJustification: "card-title-justification",
  cardTitleRequestDetails: "card-title-request-details",
  functionGroupRequestDetailPage: "function-group-request-detail-page",
  requestStatusBadge: "request-status-badge",
  apLink: (ap_accessProfile_id: string) => `ap-link-${ap_accessProfile_id}`,
  apLinkPrefix: () => "ap-link-" as TestIdPrefix,
  btnCancelItem: (item_id: string) => `btn-cancel-item-${item_id}`,
  btnCancelItemPrefix: () => "btn-cancel-item-" as TestIdPrefix,
  btnRetryAp: (item_id: string) => `btn-retry-ap-${item_id}`,
  btnRetryApPrefix: () => "btn-retry-ap-" as TestIdPrefix,
  btnToggleApSection: (item_id: string) => `btn-toggle-ap-section-${item_id}`,
  btnToggleApSectionPrefix: () => "btn-toggle-ap-section-" as TestIdPrefix,
  escalationTimeline: (step_id: string) => `escalation-timeline-${step_id}`,
  escalationTimelinePrefix: () => "escalation-timeline-" as TestIdPrefix,
  itemName: (item_id: string) => `item-name-${item_id}`,
  itemNamePrefix: () => "item-name-" as TestIdPrefix,
  itemStatus: (item_id: string) => `item-status-${item_id}`,
  itemStatusPrefix: () => "item-status-" as TestIdPrefix,
  requestItem: (item_id: string) => `request-item-${item_id}`,
  requestItemPrefix: () => "request-item-" as TestIdPrefix
} as const;
